import React from 'react';
// import classnames from 'classnames';
import PropTypes from 'prop-types';

const TextFieldGroupProfile = ({
    field, value, label, id, error, image, type, onChange, checkUserExists, disabled, divClassName, viewPassword, placeholder, passwordStatus, req
}) => (
        <div className={`${divClassName} font-medium pad-x-none`}>

            <input
                onChange={onChange}
                onBlur={checkUserExists}
                value={value}
                type={type}
                name={field}
                id={label}
                placeholder={placeholder !== "" ? placeholder : label}
                className="validate"
                disabled={disabled}
                onChangeCapture={onChange}
                onInput={onChange}
                onFocus={onChange}
                onClick={onChange}

            // autoComplete="-"
            />
            <label className="active" htmlFor={label}>{label}  {req ? "*" : ""} {image !== "" ? (<img className="question-mark" src={image} alt="" />) : ""} </label>
            {passwordStatus ? (

                type === "text" ? (<span className="show-password">
                    <a onClick={viewPassword}>
                        {' '}
                        hide <i className="material-icons hide-icon">visibility_off</i>

                    </a>
                </span>) : (<span className="show-password">
                    <a onClick={viewPassword}>
                        {' '}
                        show <i
                            className="material-icons hide-icon"
                        >
                            visibility

                                                </i>

                    </a>
                </span>)) : ""}

            {/* <input id="Email" type="text" placeholder="placeholder" className="validate" /> */}

            {error && <span className="help-block invalid ">{error}</span>}
        </div>
    );

TextFieldGroupProfile.propTypes = {
    field: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    error: PropTypes.any,
    type: PropTypes.string,
    divClassName: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.any,
    checkUserExists: PropTypes.func,
    viewPassword: PropTypes.func,
    req: PropTypes.any,
    passwordStatus: PropTypes.any,
    image: PropTypes.any
};

TextFieldGroupProfile.defaultProps = {
    type: 'text',
    disabled: false,
    req: false,
    passwordStatus: false,
    divClassName: '',
    id: '',
    image: '',
};

export default TextFieldGroupProfile;
